function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  const url = getConfig("VITE_BACKEND_URL");

  if (window.location.protocol === 'https:' && window.location.hostname === "cmdsiglo21.vitaliatec.com") {
    return "https://api-cmdsiglo21.vitaliatec.com/";
  }

  return url;
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}
